import { render, staticRenderFns } from "./ContractorInfo.vue?vue&type=template&id=46bfb69f&scoped=true"
import script from "./ContractorInfo.vue?vue&type=script&lang=js"
export * from "./ContractorInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bfb69f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46bfb69f')) {
      api.createRecord('46bfb69f', component.options)
    } else {
      api.reload('46bfb69f', component.options)
    }
    module.hot.accept("./ContractorInfo.vue?vue&type=template&id=46bfb69f&scoped=true", function () {
      api.rerender('46bfb69f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/purchaseService/components/sections/ContractorInfo.vue"
export default component.exports